import React, { useEffect, useState } from 'react'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

function MapComponent({ position, setPosition }) {
  const [center, setCenter] = useState({
    lat: position.latitude,
    lng: position.longitude
  });
  const [markerCenter, setMarkerCenter] = useState({
    lat: position.latitude,
    lng: position.longitude
  });

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(({ coords }) => {
        setPosition({
          latitude: coords.latitude,
          longitude: coords.longitude
        })
      });
    } else {
      console.log("Geolocalização não suportada pelo navegador.");
    }
  }, []);
  
  useEffect(() => {
    // Position -> Latitude e Longitude a serem considerados
    // Center -> Responsável por centralizar Marker
    setCenter({
      lat: position.latitude,
      lng: position.longitude
    })
  },[position])
  
  useEffect(() => {
    setMarkerCenter(center)
  }, [center])
  
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyDi_LKzscOj1wkn9GeYROet6_dfGfz91Kk"
  })

  const handleMarkerDragEnd = (e) => {
    setPosition({
      latitude: e.latLng.lat(),
      longitude: e.latLng.lng()
    })
  };
 
  const containerStyle = {
    height: '400px',
    width: '100%',
    border: 'none',
    borderRadius: '5px',
    overflow: 'hidden',
  };

  const markerStyle = {
    url: "https://maps.google.com/mapfiles/ms/icons/orange-dot.png",
    scaledSize: { width: 40, height: 40 },
  };

  return (
    isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
      >
        <Marker
          position={markerCenter}
          icon={markerStyle} 
          draggable={true}
          onDragEnd={handleMarkerDragEnd}
          key={markerCenter}
          visible={true}
          onLoad={(marker) => {}}
        />
      </GoogleMap>
    ) : <></>
  )
}

export default MapComponent
